<template>
  <!-- 招标管理  招标详情 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题 招标管理  招标详情-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBack">店铺管理</span>
        <i class="el-icon-arrow-right firm-clickable"></i><span @click="handelBack">订单管理</span>
        <i class="el-icon-arrow-right"></i
        ><span class="firm-clickable" @click="handelBack">{{ tender == "1" ? "招标管理" : "投标管理" }}</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center firm-clickable" @click="handelBack">{{
          tender == "1" ? "招标详情" : "投标详情"
        }}</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- 招标详情-->
        <div class="top-title">
          <p class="title">{{ tender == "1" ? "招标详情" : "投标详情" }}</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>

        <!-- 招标信息 -->
        <p class="title-p">招标信息</p>
        <div class="mine-attendContent">
          <CallForBidsMsg></CallForBidsMsg>
        </div>

        <!-- 我的参标信息 -->
        <p class="title-p title-mine" v-if="tender == '2'">我的参标信息</p>
        <div class="mine-attendContent" v-if="tender == '2'">
          <AttendContent
            :distinguish="1"
            :listArr="mineListArr"
            @handelViewOption="handelViewOption"
          ></AttendContent>
        </div>
        <!-- 招标信息 -->
        <p class="title-p">参标信息</p>
        <!-- 参标信息div -->
        <div class="attendContent">
          <AttendContent
            :distinguish="1"
            :listArr="listArr"
            @handelViewOption="handelViewOption"
          ></AttendContent>
        </div>
        <!-- 分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paging from "../../../../../components/paging.vue"; // 分页
import AttendContent from "./components/AttendContent.vue"; // 参标信息模块
import CallForBidsMsg from "./components/CallForBidsMsg.vue"; // 招标信息模块
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
      listArr: [
        {
          name: "张xx", //姓名
          address: "河南 南阳", //地址
          type: "个人", //个人/企业
          serviceType: "后端开发、LOGO设计、小程序、web网站…", //服务类型
          SalesVolume: "12354", //销量
          mark: 4, //星级
          HitHit: false, //是否中标
          id: 1,
        },
        {
          name: "张xx", //姓名
          address: "河南 南阳", //地址
          type: "企业", //个人/企业
          serviceType: "后端开发、LOGO设计、小程序、web网站…", //服务类型
          SalesVolume: "12354", //销量
          mark: 3, //星级
          HitHit: true, //是否中标
          id: 2,
        },
      ], //参标信息
      mineListArr: [
        {
          name: "张xx", //姓名
          address: "河南 南阳", //地址
          type: "个人", //个人/企业
          serviceType: "后端开发、LOGO设计、小程序、web网站…", //服务类型
          SalesVolume: "12354", //销量
          mark: 4, //星级
          HitHit: false, //是否中标
          id: 1,
        },
      ], //参标信息
      tender: "", //接收上一个页面跳转时传的key 1是招标详情  2是投标详情  （该页面为招标管理和投标管理的公用页面，用此数据来做区分）
    };
  },
  watch: {},
  components: { paging, AttendContent, CallForBidsMsg },
  created() {
    if (this.$route.query.key != "" && this.$route.query.key != undefined) {
      this.tender = this.$route.query.key;
    }
  },
  destroyed() {},
  methods: {
    // 点击查看报价及方案
    handelViewOption() {
      this.$router.push({
        path: "/HelpShop/ViewSolution",
        // key传1 招标详情   传2投标详情
        query: { key: this.tender },
      });
    },
    // 确定
    handelNext() {},

    // 返回
    handelBack() {
      // 存入select 返回/HelpShop的同时获取到select  select中的数就是该页面所在的位置

      if (this.tender == "1") {
        this.$router.push({
          path: "/HelpShop/ShopOrderSingle",
          query: { key: 3 },
        });
      } else {
        this.$router.push({
          path: "/HelpShop/ShopOrderSingle",
          query: { key: 4 },
        });
      }
    },
    // 分页
    handleCurrentChange(val) {
      // 获取 用户点击的页码/输入的页码
      this.pagingObj.currentPage = val;
      // this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  font-family: PingFangSC-Medium;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;

    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  // 招标信息 参标信息 标题
  .title-p {
    width: 85px;
    height: 25px;
    background-image: url("../../../../../assets/imgs/zhuangshi@3x.svg");
    background-size: 100% 35%;
    background-repeat: no-repeat;
    background-position-y: bottom;
    font-size: 20px;
    margin: 50px 0px 30px 0px;
  }
  .title-mine {
    width: 120px;
  }

  // 参标信息 展示区域
  .attendContent {
    width: 1140px;
    min-height: 600px;
  }
  // 我的参标信息
  .mine-attendContent {
    width: 100%;
    min-height: 120px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
